// ---------------------------------------------
// auto-generated from materia/explica-exercises.jsx
// edit the source there and run `npm run sync`
// ---------------------------------------------
import React from "react";
import { MChip, MEye, MChart } from "./prims.jsx";
import { Icon } from "../screens-cristal/primitives.jsx";
import { ExplicaShell } from "./explica-player.jsx";

// ─────────────────────────────────────────────────────────
// Generic exercise frame inside ExplicaShell
// ─────────────────────────────────────────────────────────
export const ExerciseCenter = ({ type, n, of, prompt, body, eyebrowExtra, hintLevel = 1, feedback }) => (
  <div style={{ flex: 1, display: "flex", flexDirection: "column", padding: "20px 28px 0", minHeight: 0 }}>
    {/* eyebrow */}
    <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
      <MChip variant="copper">{type}</MChip>
      <span className="mono" style={{ fontSize: 11, color: "var(--m-text-3)", letterSpacing: "0.1em" }}>EJERCICIO {n} de {of}</span>
      {eyebrowExtra}
      <span style={{ flex: 1, height: 1, background: "var(--m-line)" }}/>
      <span className="mono" style={{ fontSize: 10, color: "var(--m-text-3)" }}>timer · n/a</span>
    </div>

    {/* prompt */}
    <h2 style={{ fontSize: 24, fontWeight: 600, marginTop: 14, lineHeight: 1.25, letterSpacing: "-0.015em", textWrap: "balance" }}>
      {prompt}
    </h2>

    {/* body */}
    <div style={{ marginTop: 14, flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
      {body}
    </div>

    {/* feedback area */}
    {feedback}

    {/* secondary actions + send */}
    <div style={{ padding: "14px 0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <div style={{ display: "flex", gap: 6 }}>
        <button className="m-btn ghost sm"><Icon name="lightbulb" size={11}/> Pista {hintLevel}/3</button>
        <button className="m-btn ghost sm"><Icon name="book" size={11}/> Glosario</button>
        <button className="m-btn ghost sm"><Icon name="link" size={11}/> Fuente</button>
        <button className="m-btn ghost sm"><Icon name="help" size={11}/> Tutor</button>
        <button className="m-btn ghost sm"><Icon name="list" size={11}/> Alternativa accesible</button>
      </div>
      <div style={{ display: "flex", gap: 6 }}>
        <span style={{ display: "flex", gap: 4, marginRight: 8 }}>
          <span className="m-kbd">1</span><span className="m-kbd">2</span><span className="m-kbd">3</span><span className="m-kbd">4</span>
          <span className="m-kbd" style={{ marginLeft: 6 }}>↵</span>
        </span>
        <button className="m-btn accent"><Icon name="check" size={13}/> Enviar</button>
      </div>
    </div>
  </div>
);

// ─────────────────────────────────────────────────────────
// 1. Multiple choice · default + chart context
// ─────────────────────────────────────────────────────────
export const ScreenMExMC = () => (
  <ExplicaShell
    label="Explica · Ex · MultipleChoice"
    act={5}
    sourceProps={{ note: "EX.multiple_choice · feedback explica porqué cada distractor es débil" }}
    center={
      <ExerciseCenter
        type="multiple choice" n={2} of={4}
        prompt={<>¿Qué evidencia añade <span style={{ color: "var(--m-accent)" }}>más calidad</span> a una ruptura?</>}
        body={
          <div style={{ display: "grid", gridTemplateColumns: "1.3fr 1fr", gap: 18, flex: 1, minHeight: 0 }}>
            <div>
              <MChart width={460} height={320} caption="XYZ · 1D · contexto"
                overlays={[
                  { type: "zone", topPct: 26, bottomPct: 34, color: "copper", label: "R" },
                  { type: "marker", xPct: 70, yPct: 22, label: "decisión", kind: "decision" },
                ]}/>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {[
                { l: "Solo cruzar el nivel", kbd: "1" },
                { l: "Cierre fuera de zona", kbd: "2" },
                { l: "Cierre + volumen relativo + contexto", kbd: "3", on: true },
                { l: "Más toques previos antes de la ruptura", kbd: "4" },
              ].map((o, i) => (
                <div key={i} className={`m-option ${o.on ? "selected" : ""}`}>
                  <div className="radio"/>
                  <span style={{ flex: 1, fontSize: 13.5, color: "var(--m-text)" }}>{o.l}</span>
                  <span className="m-kbd">{o.kbd}</span>
                </div>
              ))}
            </div>
          </div>
        }
      />
    }
  />
);

// ─────────────────────────────────────────────────────────
// 2. True/False · with feedback shown (correct)
// ─────────────────────────────────────────────────────────
export const ScreenMExTF = () => (
  <ExplicaShell
    label="Explica · Ex · TrueFalse · correct"
    act={5}
    sourceProps={{ note: "EX.true_false · feedback con porqué · sin penalización al fallo" }}
    center={
      <ExerciseCenter
        type="V / F" n={1} of={4}
        prompt={<em style={{ color: "var(--m-text)", fontStyle: "normal" }} className="m-serif">"RSI alto siempre anticipa una caída."</em>}
        body={
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
            <div className="m-option" style={{ padding: "22px 18px" }}>
              <div className="radio"/>
              <span style={{ flex: 1, fontSize: 17, fontWeight: 600, letterSpacing: "0.04em", color: "var(--m-text-2)" }}>VERDADERO</span>
              <span className="m-kbd">1</span>
            </div>
            <div className="m-option correct" style={{ padding: "22px 18px" }}>
              <div className="radio" style={{ borderColor: "var(--m-positive)", background: "rgba(155,184,106,0.2)" }}>
                <span style={{ width: 8, height: 8, borderRadius: 99, background: "var(--m-positive)" }}/>
              </div>
              <span style={{ flex: 1, fontSize: 17, fontWeight: 600, letterSpacing: "0.04em" }}>FALSO</span>
              <Icon name="check" size={16} style={{ color: "var(--m-positive)" }}/>
            </div>
          </div>
        }
        feedback={
          <div className="m-feedback-correct" style={{ marginTop: 16, padding: 18 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{ width: 28, height: 28, borderRadius: 99, background: "var(--m-positive)", color: "#0f1a06", display: "grid", placeItems: "center" }}>
                <Icon name="check" size={15}/>
              </div>
              <div className="mono" style={{ fontSize: 11, color: "var(--m-positive)", letterSpacing: "0.14em", textTransform: "uppercase" }}>Correcto · porqué</div>
            </div>
            <div style={{ fontSize: 14.5, marginTop: 12, lineHeight: 1.45, textWrap: "pretty", maxWidth: 760 }}>
              El RSI mide <strong style={{ color: "var(--m-positive)" }}>momentum</strong>, no decisión. Un RSI &gt; 70 indica fuerza relativa, no agotamiento garantizado: en tendencias fuertes puede permanecer alto durante muchas sesiones.
            </div>
            <div style={{ marginTop: 12, display: "flex", flexWrap: "wrap", gap: 6 }}>
              {["momentum", "sobrecompra ≠ vender", "tendencia fuerte"].map((c, i) => (
                <span key={i} className="m-chip" style={{
                  background: "rgba(155,184,106,0.14)", borderColor: "rgba(155,184,106,0.4)", color: "var(--m-positive)"
                }}>{c}</span>
              ))}
            </div>
          </div>
        }
      />
    }
  />
);

// ─────────────────────────────────────────────────────────
// 3. Chart labeling · with tap targets
// ─────────────────────────────────────────────────────────
export const ScreenMExChartLabel = () => (
  <ExplicaShell
    label="Explica · Ex · ChartLabeling"
    act={5}
    sourceProps={{ note: "EX.chart_labeling · snap a swings · alternativa tabla con desplegable" }}
    center={
      <ExerciseCenter
        type="chart labeling" n={3} of={4}
        prompt={<>Etiqueta los swings que mantienen la <span style={{ color: "var(--m-accent)" }}>tendencia</span>.</>}
        body={
          <div style={{ display: "grid", gridTemplateColumns: "1.8fr 1fr", gap: 18, flex: 1, minHeight: 0 }}>
            <div style={{ position: "relative" }}>
              <MChart width={520} height={350} caption="ABC · 1D · 32 sesiones"
                overlays={[
                  { type: "trend", from: [10, 86], to: [90, 36], color: "rgba(216,168,104,0.4)", dashed: true },
                ]}/>
              {/* labeled swings */}
              {[
                { x: 18, y: 78, label: "HL" },
                { x: 38, y: 60, label: "HL" },
                { x: 60, y: 42, label: "HH" },
                { x: 82, y: 28, label: "?", pending: true },
              ].map((s, i) => (
                <div key={i} style={{
                  position: "absolute",
                  left: `calc(${s.x}% - 22px)`, top: `calc(${s.y}% - 22px)`,
                  width: 44, height: 44, borderRadius: 99,
                  border: `1.5px solid ${s.pending ? "var(--m-accent)" : "rgba(155,184,106,0.6)"}`,
                  background: s.pending ? "rgba(216,168,104,0.18)" : "rgba(155,184,106,0.10)",
                  display: "grid", placeItems: "center",
                  boxShadow: s.pending ? "0 0 24px rgba(216,168,104,0.45)" : "none",
                }}>
                  <span className="mono" style={{ fontSize: 10.5, color: s.pending ? "var(--m-accent)" : "var(--m-positive)", fontWeight: 600 }}>{s.label}</span>
                </div>
              ))}
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              <div>
                <MEye>Etiquetas disponibles</MEye>
                <div style={{ marginTop: 8, display: "flex", flexWrap: "wrap", gap: 6 }}>
                  {[
                    { l: "HH", c: "var(--m-positive)" },
                    { l: "HL", c: "var(--m-positive)" },
                    { l: "LH", c: "var(--m-negative)" },
                    { l: "LL", c: "var(--m-negative)" },
                  ].map((b, i) => (
                    <button key={i} className="m-chip" style={{
                      height: 36, padding: "0 16px", fontSize: 13,
                      borderColor: b.c, background: `color-mix(in oklab, ${b.c} 16%, transparent)`, color: b.c,
                    }}>{b.l}</button>
                  ))}
                </div>
              </div>

              <div className="m-panel" style={{ padding: 14 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <MEye>Tabla accesible</MEye>
                  <MChip variant="neutral">a11y</MChip>
                </div>
                <table style={{ width: "100%", marginTop: 10, fontSize: 11.5, color: "var(--m-text-2)", borderCollapse: "collapse" }}>
                  <thead>
                    <tr style={{ color: "var(--m-text-3)", textAlign: "left" }} className="mono">
                      <th style={{ fontSize: 9.5, fontWeight: 400, padding: "4px 0", letterSpacing: "0.06em" }}>vela</th>
                      <th style={{ fontSize: 9.5, fontWeight: 400, padding: "4px 0", letterSpacing: "0.06em" }}>precio</th>
                      <th style={{ fontSize: 9.5, fontWeight: 400, padding: "4px 0", letterSpacing: "0.06em" }}>etiqueta</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      { v: "08", p: "94.2", l: "HL ▾", on: true },
                      { v: "14", p: "96.7", l: "HL ▾", on: true },
                      { v: "21", p: "100.1", l: "HH ▾", on: true },
                      { v: "28", p: "102.6", l: "elegir ▾", on: false },
                    ].map((r, i) => (
                      <tr key={i} style={{ borderTop: "1px solid var(--m-line)" }}>
                        <td className="mono" style={{ padding: "6px 0" }}>{r.v}</td>
                        <td className="mono" style={{ padding: "6px 0" }}>{r.p}</td>
                        <td className="mono" style={{ padding: "6px 0", color: r.on ? "var(--m-positive)" : "var(--m-accent)" }}>{r.l}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="mono" style={{ fontSize: 10, color: "var(--m-text-3)", letterSpacing: "0.06em" }}>
                modo · tap-then-label · drag-label · ↕ desplegable accesible
              </div>
            </div>
          </div>
        }
      />
    }
  />
);

// ─────────────────────────────────────────────────────────
// 4. Compare charts · diptych
// ─────────────────────────────────────────────────────────
export const ScreenMExCompare = () => (
  <ExplicaShell
    label="Explica · Ex · CompareCharts"
    act={5}
    sourceProps={{ note: "EX.compare_charts · sincronización opcional de cursor · alternativa tabla métricas" }}
    center={
      <ExerciseCenter
        type="compare charts" n={4} of={4}
        prompt={<>¿Hay <span style={{ color: "var(--m-accent)" }}>alineación</span> o conflicto entre timeframes?</>}
        body={
          <div style={{ display: "flex", flexDirection: "column", gap: 14, flex: 1, minHeight: 0 }}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, minHeight: 0 }}>
              <div className="m-panel" style={{ padding: 10 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <MChip variant="neutral">A · diario</MChip>
                  <span className="mono" style={{ fontSize: 10, color: "var(--m-text-3)" }}>200 sesiones</span>
                </div>
                <div style={{ marginTop: 8 }}>
                  <MChart width={430} height={220} caption="XYZ · 1D" ohlcLabel={false}
                    yLabels={["110","105","100","95","90"]} xLabels={["e","f","m","a","m"]}
                    overlays={[
                      { type: "trend", from: [10, 84], to: [88, 28], color: "rgba(155,184,106,0.5)" },
                      { type: "zone", topPct: 22, bottomPct: 30, color: "default", label: "R-A" },
                    ]}/>
                </div>
              </div>
              <div className="m-panel" style={{ padding: 10 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <MChip variant="neutral">B · horario</MChip>
                  <span className="mono" style={{ fontSize: 10, color: "var(--m-text-3)" }}>72 horas</span>
                </div>
                <div style={{ marginTop: 8 }}>
                  <MChart width={430} height={220} caption="XYZ · 1H" ohlcLabel={false}
                    yLabels={["104","103","102","101","100"]} xLabels={["lun","mar","mié","jue","vie"]}
                    overlays={[
                      { type: "trend", from: [10, 32], to: [88, 78], color: "rgba(201,92,78,0.5)" },
                      { type: "zone", topPct: 60, bottomPct: 72, color: "default", label: "R-B" },
                    ]}/>
                </div>
              </div>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 10 }}>
              {[
                { l: "Alineados al alza", on: false, c: "var(--m-positive)" },
                { l: "Conflicto", on: true, c: "var(--m-accent)" },
                { l: "Sin tendencia clara", on: false, c: "var(--m-warn)" },
                { l: "Insuficiente evidencia", on: false, c: "var(--m-text-3)" },
              ].map((o, i) => (
                <div key={i} className={`m-option ${o.on ? "selected" : ""}`}>
                  <div className="radio"/>
                  <span style={{ flex: 1, fontSize: 13 }}>{o.l}</span>
                  <span className="m-kbd">{i+1}</span>
                </div>
              ))}
            </div>
          </div>
        }
      />
    }
  />
);

// ─────────────────────────────────────────────────────────
// 5. Timeline replay decision (incorrect feedback shown)
// ─────────────────────────────────────────────────────────
export const ScreenMExReplay = () => (
  <ExplicaShell
    label="Explica · Ex · ReplayDecision"
    act={5}
    sourceProps={{ note: "EX.timeline_replay_decision · pausa obligatoria en decision_pause beat" }}
    center={
      <ExerciseCenter
        type="replay con decisión" n={5} of={5}
        eyebrowExtra={<MChip variant="warn">pausa · vela 47</MChip>}
        prompt={<>En esta vela: ¿<span style={{ color: "var(--m-accent)" }}>ruptura</span>, espera o falsa probable?</>}
        body={
          <div style={{ display: "flex", flexDirection: "column", gap: 14, flex: 1, minHeight: 0 }}>
            <div>
              <MChart width={920} height={290} caption="XYZ · 1D · replay · vela 47 de 70"
                overlays={[
                  { type: "zone", topPct: 36, bottomPct: 44, color: "copper", label: "R" },
                  { type: "marker", xPct: 67, yPct: 28, label: "vela 47 · DECISIÓN", kind: "decision" },
                ]}/>
              {/* replay timeline */}
              <div className="m-panel" style={{ marginTop: 8, padding: "8px 12px", display: "flex", alignItems: "center", gap: 12 }}>
                <button className="m-iconbtn" style={{ width: 28, height: 28 }}><Icon name="pause" size={12}/></button>
                <div style={{ flex: 1, position: "relative", height: 6 }}>
                  <div style={{ position: "absolute", inset: 0, background: "rgba(216,196,160,0.1)", borderRadius: 3 }}/>
                  <div style={{ position: "absolute", left: 0, top: 0, bottom: 0, width: "67%", background: "linear-gradient(90deg, var(--m-primary), var(--m-accent))", borderRadius: 3 }}/>
                  <div style={{ position: "absolute", left: "67%", top: -4, bottom: -4, width: 2, background: "var(--m-accent)" }}/>
                </div>
                <span className="mono" style={{ fontSize: 10, color: "var(--m-text-3)" }}>47 / 70 · decision_pause</span>
              </div>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12 }}>
              {[
                { l: "Ruptura", k: "1", on: true },
                { l: "Espera", k: "2" },
                { l: "Falsa probable", k: "3" },
              ].map((o, i) => (
                <div key={i} className={`m-option ${o.on ? "selected incorrect" : ""}`} style={{ padding: "18px 16px" }}>
                  <div className="radio"/>
                  <span style={{ flex: 1, fontSize: 15, fontWeight: 600 }}>{o.l}</span>
                  <span className="m-kbd">{o.k}</span>
                </div>
              ))}
            </div>
          </div>
        }
        feedback={
          <div className="m-feedback-incorrect" style={{ marginTop: 16, padding: 16 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{ width: 26, height: 26, borderRadius: 99, background: "rgba(201,92,78,0.16)", color: "var(--m-negative)", display: "grid", placeItems: "center" }}>
                <Icon name="retry" size={13}/>
              </div>
              <div className="mono" style={{ fontSize: 10.5, color: "var(--m-negative)", letterSpacing: "0.14em", textTransform: "uppercase" }}>Demasiado pronto · porqué</div>
            </div>
            <div style={{ fontSize: 13.5, marginTop: 10, lineHeight: 1.4, textWrap: "pretty", maxWidth: 760 }}>
              En la vela 47 el cruce <em>aún</em> no era cierre confirmado. Mira lo que pasa en velas 48-49: el precio vuelve dentro de la zona. Lo que parecía ruptura era una <strong style={{ color: "var(--m-negative)" }}>falsa</strong>.
            </div>
            <div style={{ marginTop: 10, display: "flex", gap: 8 }}>
              <button className="m-btn ghost sm"><Icon name="play" size={11}/> Continuar replay (revela 2 velas)</button>
              <button className="m-btn ghost sm"><Icon name="retry" size={11}/> Reintentar</button>
            </div>
          </div>
        }
      />
    }
  />
);

// ─────────────────────────────────────────────────────────
// 6. Explain in words · with rubric chips
// ─────────────────────────────────────────────────────────
export const ScreenMExExplain = () => (
  <ExplicaShell
    label="Explica · Ex · ExplainInWords"
    act={5}
    sourceProps={{ note: "EX.explain_in_words · rubric semántico · feedback metacognitivo + dictado por voz disponible" }}
    center={
      <ExerciseCenter
        type="explica en palabras" n={4} of={4}
        prompt={<>Explica en <span style={{ color: "var(--m-accent)" }}>dos frases</span> qué evidencia falta para hablar de agotamiento.</>}
        body={
          <div style={{ display: "grid", gridTemplateColumns: "1.4fr 1fr", gap: 18, flex: 1, minHeight: 0 }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div className="m-panel-sunk" style={{
                padding: 16, flex: 1, minHeight: 180,
                background: "var(--m-bg-deep)", borderRadius: 6, display: "flex", flexDirection: "column",
              }}>
                <div style={{ fontSize: 14, color: "var(--m-text)", lineHeight: 1.55 }}>
                  Para hablar de agotamiento no basta con un RSI alto. Necesito ver <span style={{ background: "rgba(216,168,104,0.18)", padding: "0 4px" }}>divergencia con el precio</span> en al menos dos máximos, una caída del <span style={{ background: "rgba(155,184,106,0.18)", padding: "0 4px" }}>volumen relativo</span> y un cambio de <span style={{ background: "rgba(155,184,106,0.18)", padding: "0 4px" }}>estructura</span> con un mínimo decreciente.
                </div>
                <div style={{ flex: 1 }}/>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 12 }}>
                  <div style={{ display: "flex", gap: 8 }}>
                    <button className="m-btn ghost sm"><Icon name="mic" size={11}/> Dictado</button>
                    <button className="m-btn ghost sm"><Icon name="x" size={11}/> Limpiar</button>
                  </div>
                  <span className="mono" style={{ fontSize: 10.5, color: "var(--m-text-3)" }}>198 / 280</span>
                </div>
              </div>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              <div className="m-panel" style={{ padding: 14 }}>
                <MEye>Rubric semántico</MEye>
                <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 6 }}>
                  {[
                    { l: "evidencia múltiple", on: true },
                    { l: "contexto", on: true },
                    { l: "cautela prudente", on: true },
                    { l: "fuente / timestamp", on: false },
                    { l: "estructura mencionada", on: true },
                    { l: "ejemplos de invalidación", on: false },
                  ].map((r, i) => (
                    <div key={i} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <Icon name={r.on ? "check" : "circle"} size={13} style={{ color: r.on ? "var(--m-positive)" : "var(--m-text-3)" }}/>
                      <span style={{ fontSize: 12.5, color: r.on ? "var(--m-text)" : "var(--m-text-3)" }}>{r.l}</span>
                    </div>
                  ))}
                </div>
                <div className="m-divider" style={{ margin: "12px 0" }}/>
                <div className="mono" style={{ fontSize: 11, color: "var(--m-text-2)" }}>4 / 6 criterios cubiertos</div>
                <div className="m-meter" style={{ marginTop: 6 }}>
                  <div className="fill" style={{ width: "66%" }}/>
                </div>
              </div>

              <div className="m-misconception" style={{ padding: 14 }}>
                <div className="lbl">no se evalúa exact match</div>
                <div style={{ fontSize: 11.5, color: "var(--m-text-2)", marginTop: 6, lineHeight: 1.4 }}>
                  Evaluamos qué criterios cubre tu razonamiento, no si usas las palabras exactas del libro.
                </div>
              </div>
            </div>
          </div>
        }
      />
    }
  />
);
